module.exports = __webpack_public_path__ + "img/chatbot-branco.6b7b1bb1.png";